require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-is-the-world-bank-effectively-supporting-transport.json") })
        }
      }, "path---en-us-update-is-the-world-bank-effectively-supporting-transport");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-is-the-world-bank-effectively-supporting-transport!./.cache/json/en-us-update-is-the-world-bank-effectively-supporting-transport.json
// module id = 765
// module chunks = 231608221292675